module.exports = __webpack_public_path__ + "img/bg.240546c6.png";